// extracted by mini-css-extract-plugin
module.exports = {"SideBySides":"SideBySides_SideBySides__WgDOh","title":"SideBySides_title__0qsKN","items":"SideBySides_items__j44we","stickySpacer":"SideBySides_stickySpacer__6Mw_z"};